import { tw } from "@careinfo/tailwind";
import { Control, Controller } from "react-hook-form";
import { PhoneInput } from "react-international-phone";
import "./style.css";
import { useEffect, useState } from "react";

interface Props {
  control: Control<any, any>;
  name: string;
  errors: any;
  required?: boolean;
  label: string;
}
const PhoneNumberField = ({
  control,
  name,
  errors,
  label,
  required,
}: Props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <label className={tw`w-full mt-2 text-left `}>
      <span className={tw``}>
        {label}
        {required && <span className={tw`text-red-600 text-xl`}>*</span>}
      </span>
      <div className={tw`w-full`}>
        <Controller
          name={name}
          control={control}
          render={({ field }) =>
            field ? (
              <PhoneInput
                className={tw`w-full focus:outline-none bg-[#EEF5F4]  mt-2`}
                inputStyle={{
                  backgroundColor: "inherit",
                  border: "none",
                  width: "100%",
                }}
                countrySelectorStyleProps={{
                  buttonStyle: { backgroundColor: "inherit" },
                  dropdownStyleProps: {
                    listItemClassName: tw`border`,
                  },
                }}
                defaultCountry="np"
                value={field.value || ""}
                onChange={(value) => {
                  if (isMounted) {
                    field.onChange(value);
                  }
                }}
              />
            ) : null
          }
        />
        {errors && (
          <span
            className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
          >
            <span className={tw`block`}>{errors.message}</span>
          </span>
        )}
      </div>
    </label>
  );
};

export default PhoneNumberField;
